const FnPool = [];
const FnPoolKey = [];
export class UtilService {
    /**
     * 生成32位Guid
     * @returns {string}
     * @constructor
     */
    static Guid() {
        let timestamp = new Date().getTime();
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (timestamp + Math.random() * 16) % 16 | 0;
            timestamp = Math.floor(timestamp / 16);
            return (c === 'x' ? r : (r & 3 | 8)).toString(16);
        });
    }
    /**
     * 注册把函数注册成window函数
     * @param {Function} fn
     * @returns {string}
     * @constructor
     */
    static RegisterWinFunc(fn) {
        const index = FnPool.indexOf(fn);
        if (~index) {
            return FnPoolKey[index];
        }
        const fnName = "Fn_" + this.Guid();
        FnPoolKey.push(fnName);
        FnPool.push(fn);
        window ? (window[fnName] = fn) : (window[fnName] = fn);
        return fnName;
    }
    static ContentType(extension) {
        extension = extension.toLocaleLowerCase();
        switch (extension) {
            case "doc":
            case "rtf":
                return "application/msword";
            case "pdf":
                return "application/pdf";
            case "docx":
                return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            case "xls":
                return "application/vnd.ms-excel";
            case "xlsx":
                return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            case "ppt":
                return "application/vnd.ms-powerpoint";
            case "pptx":
                return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
            default:
                return "application/octet-stream";
        }
    }
    static FileExtension(name) {
        return name.split(".").pop() || "";
    }
}
